//@flow

import React from "react"
import { PersistGate } from "redux-persist/lib/integration/react"
import { IntlProvider } from "react-intl"
import { compose, withState, withHandlers, lifecycle } from "recompose"
import { withRouter } from "react-router"
import qs from "query-string"
import ErrorHandler from "./components/error-handler"
import { persistor } from "./index"
import LocalizedRoutes from "./i18n/LocalizedRoutes"
import { messages, locale, supportedLanguages } from "./i18n"
import flattenMessages from "./utils/flattenIntlMessages"

/**
 * Consider making this a class component, might also help with weird Safari behavior
 * since we can simply re-render on CDM (to make sure Safari has the localStorage data we need.)
 */

const App = (props: any) => {
  return (
    <main>
      <IntlProvider locale={locale} messages={props.i18n.messages}>
        <ErrorHandler>
          <PersistGate loading="loading..." persistor={persistor}>
            <LocalizedRoutes {...props} />
          </PersistGate>
        </ErrorHandler>
      </IntlProvider>
    </main>
  )
}

export default compose(
  withRouter,
  withState("i18n", "switchLocale", {
    messages: flattenMessages(
      messages[localStorage.getItem("currentLocale") || locale]
    ),
    supportedLanguages,
    currentLocale: localStorage.getItem("currentLocale") || locale
  }),
  withHandlers({
    toFrench: ({ switchLocale }) => () => handleToFrench({ switchLocale }),
    toEnglish: ({ switchLocale }) => () => handleToEnglish({ switchLocale })
  }),
  lifecycle({
    componentWillMount() {
      const { location } = this.props
      const { lang } = qs.parse(location.search)
      if (lang === "fr") {
        this.props.toFrench()
        localStorage.setItem("currentLocale", "fr-CA")
      } else {
        this.props.toEnglish()
        localStorage.setItem("currentLocale", "en-US")
      }
    }
  })
)(App)

const handleToFrench = ({ switchLocale }) => {
  localStorage.setItem("currentLocale", "fr-CA")
  return switchLocale({
    messages: flattenMessages(messages["fr-CA"]),
    currentLocale: localStorage.currentLocale || locale
  })
}

const handleToEnglish = ({ switchLocale }) => {
  localStorage.setItem("currentLocale", "en-US")
  return switchLocale({
    messages: flattenMessages(messages["en-US"]),
    currentLocale: localStorage.currentLocale || locale
  })
}



// WEBPACK FOOTER //
// ./src/App.js